import './book-room-modal.scss';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import BookLoungeInfo from '../../pages/book-lounge/BookLoungeInfo';
import BookSuccessMessage from '../../pages/book-lounge/BookSuccessMessage';
import {
  useCloseOldModal,
  useModalData,
} from '../../../store/modal/modalHooks';
import { LoungeResource } from '../../../store/lounges/loungesManagementTypes';
import CancellationPolicy from '../../shared/cancellation-policy/CancellationPolicy';
import BookLoungeFormContainer from '../../pages/book-lounge/BookLoungeFormContainer';
import BookContainer from '../../shared/book-components/BookModalComponent/BookModalComponent';

const BookLoungeModal = () => {
  const currentDate = new Date();
  const modalData = useModalData();
  const closeModal = useCloseOldModal();
  const [showSuccessPage, setShowSuccessPage] = useState(false);
  const [showCancellationPolicy, setShowCancellationPolicy] = useState(false);

  const lounge: LoungeResource = modalData?.data.lounge;
  const defaultValues = {
    date: [currentDate],
    start: '',
    end: '',
    numberOfParticipants: '',
  };

  if (!lounge) {
    closeModal();
  }

  const form = useForm({ defaultValues });
  const {
    formState: { errors },
  } = form;

  return (
    <div className="book-room-modal">
      <BookContainer
        infoComponent={
          !showCancellationPolicy ? (
            <BookLoungeInfo lounge={lounge} form={form} />
          ) : (
            <CancellationPolicy policyId={lounge?.policyId} />
          )
        }
        formComponent={
          !showSuccessPage ? (
            <BookLoungeFormContainer
              form={form}
              lounge={lounge}
              setShowSuccessPage={setShowSuccessPage}
              setShowCancellationPolicy={setShowCancellationPolicy}
              showCancellationPolicy={showCancellationPolicy}
            />
          ) : (
            <BookSuccessMessage />
          )
        }
      />
    </div>
  );
};

export default BookLoungeModal;
